import { createAsyncThunk, createSlice, createSelector } from '@reduxjs/toolkit'

import request from '~/apis/request'
import { loadingStates } from '~/config/constant'
import { getInfoRestaurant } from '~/utils'

const defaultPaging = { current_page: 1, limit: 10, total_page: 1, total: 0 }

export const fetchSearchFoodList = createAsyncThunk(
  'searchFood/fetchSearchFoodList',
  async ({ keyword = '', page = 1 }) => {
    const { restaurantId } = getInfoRestaurant()
    const params = {}
    if (keyword) params.keyword = keyword.trim()
    if (page) params.page = page
    params.limit = 500 // load hết ra vì hiện tại có video menu
    const response = await request().get(`/restaurants/${restaurantId}/food_items`, { params })
    return response.data
  },
)

const searchSlice = createSlice({
  name: 'searchFood',
  initialState: {
    error: null,
    loading: loadingStates.idle,
    listFoodSearch: [],
    paging: defaultPaging,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchFoodList.pending, (state) => {
        state.loading = loadingStates.pending
      })
      .addCase(fetchSearchFoodList.fulfilled, (state, action) => {
        state.loading = loadingStates.success
        state.error = null

        const { data } = action.payload
        if (data.length > 0) {
          const { paging } = action.payload
          const { current_page } = paging

          if (current_page === 1) {
            // trường hợp ban đầu mounted hoặc thay đổi ngôn ngữ
            state.listFoodSearch = data
          } else state.listFoodSearch = state.listFoodSearch.concat(data)

          state.paging = paging
        } else {
          state.listFoodSearch = data
          state.paging = defaultPaging
        }
      })
      .addCase(fetchSearchFoodList.rejected, (state, action) => {
        state.loading = loadingStates.error
        state.error = action.error.code
      })
  },
})

export const listFoodSearchSelector = (state) => state.searchFood

// Bọc createSelector để tối ưu performance
export const foodItemsSearch = createSelector(
  listFoodSearchSelector,
  (listFoodSearch) => listFoodSearch,
)

export default searchSlice.reducer
